import {register} from 'dna-react-ioc'
import {
    ValidateEmailStore,
    CreatePasswordStore,
    ValidateOtpCodeStore,
    ValidateRefCodeStore
} from '@/stores'
import {
    ValidateEmailStoreSymbol,
    CreatePasswordStoreSymbol,
    ValidateOtpCodeStoreSymbol,
    ValidateRefCodeStoreSymbol,
    IValidateEmailStore,
    ICreatePasswordStore,
    IValidateOtpCodeStore,
    IValidateRefCodeStore
} from '@/pages/signUp'

export const signUpInitState = () => {
    register<IValidateEmailStore>(ValidateEmailStoreSymbol)
        .to(ValidateEmailStore)
        .inSingletonScope()

    register<ICreatePasswordStore>(CreatePasswordStoreSymbol)
        .to(CreatePasswordStore)
        .inSingletonScope()

    register<IValidateOtpCodeStore>(ValidateOtpCodeStoreSymbol)
        .to(ValidateOtpCodeStore)
        .inSingletonScope()

    register<IValidateRefCodeStore>(ValidateRefCodeStoreSymbol)
        .to(ValidateRefCodeStore)
        .inSingletonScope()
}
